import React, { useEffect, useState } from "react";
import heart from "../ulits/images/heart.svg";
import locationicon from "../ulits/images/location_icon.svg";
import { configs } from "../config";
import { Link } from "react-router";

function Footer(props) {
  const [config, setConfig] = useState({});

  useEffect(() => {
    setConfig(props?.configData);
  }, [props?.configData]);

  const year = new Date().getFullYear();

  return (
    <div className="site-footer">
      <div className="footer-top">
        {config && Object.keys(config).length > 0 && (
          <div className="container">
            <div className="footer-logo text-center">
              <Link to="/">
                <img
                  src={
                    config &&
                    config.Footer_logo &&
                    `${configs.localApiUrl}${config?.Footer_logo}`
                  }
                  onClick={() => window.scrollTo(0, 0)}
                  alt="footer logo"
                />
              </Link>
            </div>

            <div className="footer-content first-content">
              <div class="footer_spanish">
                <div class="footer-column">
                  <p>
                    <img src={locationicon} alt="location-icon" />
                    {config && config?.Address_Line_1}
                  </p>
                </div>
                <div class="footer-column">
                  <p>
                    {/* <img src={locationicon} alt="location-icon" />
                    {config && config?.Address_Line_1} */}
                  </p>
                </div>
                <div class="footer-column">
                  <p> <Link to={`tel:${config && config.Free_phone}`}>
                    Free Phone: {config && config.Free_phone}
                  </Link></p>
                  <p> <Link to={`tel:${config && config.Landline}`}>
                    Landline : {config && config.Landline}
                  </Link></p>
                </div>
                <div class="footer-column">
                  <p> <Link to={`tel:${config && config.Contact_Number}`}>
                    Mobile : {config && config.Contact_Number}
                  </Link></p>
                  <p>

                    <Link to={`mailto:${config && config.Support_Email}`}>
                      Email : {config && config.Support_Email}
                    </Link>
                  </p>
                </div>
              </div>
              {/* <div className="list-unstyled">
                <p>
                  <img src={locationicon} alt="location-icon" />
                  {config && config?.Address_Line_1}
                </p>
              </div> */}
              {/* <div className="list-unstyled">
                    <Link>
                      <img src={locationicon} alt="location-icon" />
                      {config && config?.Address_Line_2}
                    </Link>
                  </div> */}
            </div>
            {/* <div className="footer-content second-content">
                  <div className="list-unstyled">
                    <Link>
                      <img src={locationicon} alt="location-icon" />
                      {config && config?.Address_Line_3}
                    </Link>
                  </div>
                  <div className="list-unstyled">
                    <Link>
                      <img src={locationicon} alt="location-icon" />
                      {config && config?.Address_Line_4}
                    </Link>
                  </div>
                </div> */}

            {/* <div className="footer-content third-content">
              <div className="list-unstyled">
                <div className="list-unstyled">
                  <Link to={`tel:${config && config.Free_phone}`}>
                    FREE PHONE : {config && config.Free_phone}
                  </Link>
                </div>
                <Link to={`tel:${config && config.Landline}`}>
                  LANDLINE : {config && config.Landline}
                </Link>
                <Link to={`tel:${config && config.Contact_Number}`}>
                  MOBILE : {config && config.Contact_Number}
                </Link>
                <Link to={`mailto:${config && config.Support_Email}`}>
                  EMAIL : {config && config.Support_Email}
                </Link>
              </div>
            </div> */}
          </div>
        )}
      </div>
      <div className="footer-bottom">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <ul className="list-inline">
                <li>
                  <Link to="/terms">Terms of use</Link>
                </li>
                <li>
                  <Link to="/privacy">Privacy</Link>
                </li>
              </ul>
              <p>
                &copy; {year} Copyright We Buy Any Spanish Left Hand Drive Cars.com
                Limited. All Rights Reserved.
              </p>
              <div className="loyalty-text">
                made with
                <em>
                  <img src={heart} alt="heart" />
                </em>
                by
                <a href="https://softorigin.co.uk/" target="_blank">
                  {" "}
                  Soft Origin
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Footer;
